import { render, staticRenderFns } from "./homeDashboardContractStatistics.vue?vue&type=template&id=0c5c9e23&scoped=true"
import script from "./homeDashboardContractStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardContractStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardContractStatistics.vue?vue&type=style&index=0&id=0c5c9e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c9e23",
  null
  
)

export default component.exports